import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Users, UserCheck, FileText, Briefcase } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import styles from './Dashboard.module.css'

const sections = [
  {
    to: '/users',
    icon: <Users size={24} />,
    title: 'Users',
    desc: 'View, create, and update user accounts',
  },
  {
    to: '/clients',
    icon: <UserCheck size={24} />,
    title: 'Clients',
    desc: 'Manage your client list',
  },
  {
    to: '/about-us',
    icon: <FileText size={24} />,
    title: 'About Us',
    desc: 'Edit the public About Us page',
  },
  {
    to: '/services-manage',
    icon: <Briefcase size={24} />,
    title: 'Services',
    desc: 'Manage the services you offer',
  },
]

export default function Dashboard() {
  const { user, logout, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && (!user || user.role !== 'admin')) {
      navigate('/login', { replace: true })
    }
  }, [user, loading, navigate])

  const handleLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  if (loading || !user) return null

  return (
    <main className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Dashboard</h1>
        <button onClick={handleLogout} className="btn btn-green">
          Logout
        </button>
      </div>
      <p className={styles.welcome}>Welcome back, {user.name || user.username}</p>

      <p className={styles.sectionTitle}>Manage</p>
      <div className={styles.cards}>
        {sections.map(({ to, icon, title, desc }) => (
          <Link key={to} to={to} className={styles.card}>
            <span className={styles.cardIcon}>{icon}</span>
            <span className={styles.cardTitle}>{title}</span>
            <span className={styles.cardDesc}>{desc}</span>
          </Link>
        ))}
      </div>
    </main>
  )
}
